
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import observaciones from './barra-ventas-observaciones.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            observaciones,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get Modo() { return this.ControladorBarras.Vista.Modo; }
        public set Modo( x: string ) { this.ControladorBarras.Vista.Modo = x; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }


        mounted()
        {
            this.Eventos.push( this.ControladorBarras.Vista.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'menu' )
                {
                    this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 300;
                }
            } ) );

            this.SubModo = 'menu';
            this.Iniciar();
        }


        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {
            this.Cargando = true;

            this.Cargando = false;
        }

        public async Abrir( item: string )
        {
            this.Modo = item;
        }


        Cerrar()
        {
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
